import { useContext, useEffect, useState } from "react";
import AnalysisFilterViewModel from "../ViewModels/AnalysisFilterViewModel";
import { APIContext } from '../../Contexts/APIContext';
import ReturnViewModel from "../../Contexts/ReturnViewModel";
import Grid from '@mui/material/Grid2';
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

interface IProps {
    state: AnalysisFilterViewModel;
    updateState: (properties: Partial<AnalysisFilterViewModel>, callback?: (newState?: AnalysisFilterViewModel) => void) => Promise<void>;
}

export interface TimeSliceViewModel {
    key: number;
    valid: boolean;
    error: string;
}


export default function LocationType({ state, updateState }: IProps) {
    const { post } = useContext(APIContext);
    const [loading, setLoading] = useState<boolean>(true);
    const [timeSlices, setTimeSlices] = useState<TimeSliceViewModel[]>([]);

    //Out of order for the columns to be in the right order
    const allTimeSlices = [5, 8, 6, 9, 7, 10];

    useEffect(() => {
        updateSlices()
    }, [])

    useEffect(() => {
        updateSlices()
    }, [state.landUseMain,
    state.landUseSub,
    state.mode,
    state.startYear,
    state.endYear,
    state.locationType]
    )

    const updateSlices = () => {
        setLoading(true)
        post(
            "TimeSlice",
            "GetValidTimeSlices",
            state,
            (response: ReturnViewModel | null | undefined) => {
                setLoading(false);

                if (Array.isArray(response)) {
                    setTimeSlices(response);
                    if (!response.includes(state.timeSlice)) {
                        updateState({
                            timeSlice: null,
                        })
                    }
                } else {
                    setTimeSlices([]);
                }
            }
        )
    }

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        var index = Number.parseInt((event.target as HTMLInputElement).value)

        updateState({
            timeSlice: index,
        })
    }

    return (
        <>
            <Grid container component={Paper} size={12} padding={2}>
                <Typography>Time Period</Typography>

                {loading ? (
                    <Box display="flex" justifyContent="center" alignItems="center" width="100%" padding={2}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <>
                        <Grid container size={12}>
                            <Grid size={8}>
                                <RadioGroup onChange={handleChange} value={state.timeSlice} sx={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)" }}>
                                    {allTimeSlices.map((value) => {
                                        return (
                                            <FormControlLabel
                                                key={value}
                                                value={value}
                                                control={<Radio />}
                                                label={
                                                    <>
                                                        <Typography>{value} Years</Typography>
                                                        <Typography variant="caption"><i>{timeSlices.find(f => f.key == value)?.error}</i></Typography>
                                                    </>
                                                }
                                                disabled={!timeSlices.find(f => f.key == value)?.valid}
                                            />
                                        );
                                    })}
                                </RadioGroup>
                            </Grid>
                            <Grid size={4}>
                                {(state.timeSlice && (state.endYear + 1 - state.startYear) % state.timeSlice != 0) &&
                                    <Typography color="info">Due to the size of this time slice and your selected start and end year, your effective start year for this slice will be <b>{state.startYear + (state.endYear + 1 - state.startYear) % state.timeSlice}</b> to avoid a partial time slice.</Typography>
                                }
                            </Grid>
                        </Grid>
                    </>
                )}
            </Grid>
        </>
    )
}